<app-modal-card>
  <app-svg class="fg-vert-1" svgPath="assets/svg/user.svg" width="48" height="48" />

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  @if (subtitle()) {
  <p class="text-[14px] fg-gris-1 text-center mt-[12px] whitespace-pre-line">{{ subtitle() }}</p>
  }

  <div class="flex flex-col gap-[10px] w-[400px] mt-auto">
    <form [formGroup]="form" class="mt-[30px]">
      <label class="block text-[16px] font-semibold fg-noir-2">
        {{ countLabel() }}
      </label>
      <div class="mt-[16px] flex items-center gap-[10px]">
        <button type="button" (click)="decrement()" [disabled]="form.controls.count.value <= 1"
          class="size-[58px] shrink-0 rounded-[5px] border border-gris-3 bg-white flex items-center justify-center fg-noir-2 text-[28px] font-semibold leading-none transition-colors"
          [class.cursor-pointer]="form.controls.count.value > 1"
          [class.hover:bg-gris-4]="form.controls.count.value > 1"
          [class.opacity-40]="form.controls.count.value <= 1"
          [class.cursor-not-allowed]="form.controls.count.value <= 1">
          -
        </button>
        <input type="number" formControlName="count" min="1" [max]="maxCount()"
          class="h-[58px] w-full border border-solid border-gris-3 rounded-[5px] p-[16px] text-[14px] text-center [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" />
        <button type="button" (click)="increment()" [disabled]="form.controls.count.value >= maxCount()"
          class="size-[58px] shrink-0 rounded-[5px] flex items-center justify-center fg-blanc text-[28px] font-semibold leading-none transition-colors"
          [class.bg-vert-1]="form.controls.count.value < maxCount()"
          [class.cursor-pointer]="form.controls.count.value < maxCount()"
          [class.bg-gris-3]="form.controls.count.value >= maxCount()"
          [class.cursor-not-allowed]="form.controls.count.value >= maxCount()">
          +
        </button>
      </div>
      @if (requiredErrorMessage() && form.controls.count.invalid && form.controls.count.touched) {
      <p class="text-[13px] fg-rose-1 mt-[8px]">{{ requiredErrorMessage() }}</p>
      }

      <label class="block text-[16px] font-semibold fg-noir-2 mt-[20px]">
        {{ commentLabel() }}<span class="fg-rose-1">*</span>
      </label>
      <textarea formControlName="comment" rows="3" [placeholder]="commentPlaceholder()"
        class="mt-[16px] w-full border border-solid border-gris-3 rounded-[5px] p-[16px] text-[14px] resize-none"></textarea>
      @if (commentRequiredErrorMessage() && form.controls.comment.invalid && form.controls.comment.touched) {
      <p class="text-[13px] fg-rose-1 mt-[8px]">{{ commentRequiredErrorMessage() }}</p>
      }
    </form>

    <div class="flex gap-[10px]">
      <button type="button"
        class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
        (click)="cancelClick.emit()">
        {{ cancelLabel() }}
        <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
      </button>
      <button type="button"
        class="h-[58px] w-full px-[20px] flex items-center justify-center bg-vert-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="form.invalid"
        (click)="onConfirm()">
        {{ confirmLabel() }}
      </button>
    </div>
  </div>
</app-modal-card>